import { typedQueryClient, useTypedMutation } from "hooks";
import { LeadsQueryKeys } from "modules/LeadsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Snooze } from "models";

export const useLeadsSnoozedAppendSnoozeMutation = () =>
  useTypedMutation<Snooze, number>({
    mutationFn: async payload => (await ApiInstance.post("/snoozes/append", payload)).data.id,
    onSuccess: (payload, snoozeId) => {
      const snoozedLeads = typedQueryClient.getQueryData(LeadsQueryKeys.listSnoozed);
      if (!snoozedLeads) return;

      typedQueryClient.setQueryData(LeadsQueryKeys.listSnoozed, {
        ...snoozedLeads,
        items: [...(snoozedLeads.items ?? []), { ...payload, id: snoozeId }],
        nb_items: snoozedLeads.nb_items + 1
      });
    }
  });
